import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenSingleImagePreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-single-image-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { DesktopFrameComponent } from '../../../preview-common/desktop-frame/desktop-frame.component';

@Component({
    selector: 'app-gen-display-ad-desktop-16',
    imports: [CommonModule, DesktopFrameComponent],
    templateUrl: './display-ad-desktop-16.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/display/display-desktop-styles.scss',
        './display-ad-desktop-16.component.scss',
    ]
})
export class DisplayAdDesktop16PreviewComponent {
  @Input() data!: GenSingleImagePreviewData;

  /** This placement's creative slot is the square format, as placements 2 and 15 are. */
  readonly creativeFormat: CreativeFormat = 'square';

  /** Full dimensions, carried as the placeholder's tooltip. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  /** This slot is a thumbnail — too narrow for the pixel label, so it shows the ratio. */
  readonly missingDimensionShortLabel = CreativeImageRouterHelper.shortLabelFor(this.creativeFormat);

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }

  /**
   * Row count for the skeleton article text between the ad and the image block
   * below it. The mock draws four full lines and a short one, and only the count
   * matters, so the array is empty on purpose.
   */
  readonly bodyBars = Array.from({ length: 5 });

  /** The publisher site nav, drawn as inert pills. Count only, as above. */
  readonly navItems = Array.from({ length: 4 });
}
